

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface UnitMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface UnitMst {
    snomedCode: string;
    id?: any;
    tenantId?: any;
    branchId?: any;
    code:any;
    name:string;
    isActive:string;
    
    parameters?: UnitMstParameter[];
    links?: any;
}


export abstract class UnitMstData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<UnitMst[]>;
    abstract create(url: string, data: UnitMst): Observable<UnitMst[]>;
    abstract update(url: string, data: UnitMst): Observable<UnitMst>;
    abstract delete(url: string): Observable<any>;
    abstract postData(url:string,data:any[]):Observable<any>;
}
